<div class="basicrow tabtopb f-black roboto-r f-reg">
  <div class="basicr-line f-big">
    Caracter&iacute;sticas de Tu Equipo
  </div>
  <div class="basicrow m-top-i" *ngIf="this.equipmentSubLenght!=0">
    <div class="row">
      <div class="ajustes-consulta">
        <div class="row">
          <div class="text-center">
            <img width="100%" class="ph-equip" src="{{ph_img}}">
          </div>
          <div class="ajustes-padd">
            <div class="basicrow f-big">
              {{desc_equ}}
            </div>
            <div>
              <div class="basicrow warr-msg"
                *ngIf="this.warrantyStatusinfo[this.index]!='' && this.warrantyStatusinfo[this.index]!=null">
                <div class="updt-textcont roboto-r f-black">
                  <div class="warr-1">
                    <img class="war-sta" src="../../../assets/images/ico_estatus_de_garantia.png">
                  </div>
                  <div class="warr-2">
                    <div class="basicrow f-big warr-status roboto-b">Estatus de Garantía</div>
                    <div class="basicrow desc-warr-stat">{{this.warrantyStatusinfo[this.index]}}</div>
                    <div class="text-right fecha-warr-stat">Fecha:
                      {{this.date_report[this.index]|date:'yyyy-MM-dd HH:mm'}} </div>
                  </div>
                </div>
                <div class="logline full warr-msg"></div>
              </div>
            </div>
            <div class="basicrow m-top" style="margin-top: 30px">
              <div class="userinfo nomtops full bot-mobile">
                <div class="basicrow">
                  <div class="basicrow">
                    <div class="basicrow f-bmed roboto-b">
                      Caracter&iacute;sticas
                    </div>
                    <div class="redstat m-top-ii">
                      <div class="autorow roboto-r pull-left">
                        IMEI
                      </div>
                      <div class="autorow roboto-b pull-right">
                        {{this.eSNField[this.index]}}
                      </div>
                    </div>
                    <div class="redstat m-top-ii" *ngIf="mark!='not_set'">
                      <div class="autorow roboto-r pull-left">
                        Marca
                      </div>
                      <div class="autorow roboto-b pull-right">
                        {{mark}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="userinfo nomtops full margin-top-sva" *ngIf="instal_equ > 0">
                <div class="basicrow" style="height: 34%">
                  <div class="redstat">
                    <div class="autorow roboto-r pull-left">
                      Monto Cuota
                    </div>
                    <div class="autorow roboto-b pull-right">
                      {{val_ins_equ| currency }}
                    </div>
                  </div>
                  <div class="redstat m-top-ii">
                    <div class="autorow roboto-r pull-left">
                      Cuotas Restantes
                    </div>
                    <div class="autorow roboto-b pull-right">
                      {{instal_equ}}
                    </div>
                  </div>
                  <div class="redstat m-top-ii">
                    <div class="autorow roboto-r pull-left">
                      Total
                    </div>
                    <div class="autorow roboto-b pull-right">
                      {{this.totalDebt[this.index]| currency }} 
                    </div>
                  </div>
                </div>
              </div>
              <div class="basicrow m-top" *ngIf="instal_equ > 0">
                <div class="basicrow roboto-b">
                  Deseo:
                </div>
              </div>

              <div class="basicrow" *ngIf="instal_equ > 0">
                <div class="autorow pull-left full-c-i">
                  <div class="autorow pull-left m-top m-right">
                    <input type="radio" name="paymentType" (click)="this.changeType(1,this.index)" value="1"> Pagar
                    deuda total
                  </div>

                  <div class="autorow pull-left m-top">
                    <input type="radio" name="paymentType" (click)="this.changeType(2,this.index)" value="2"> Pagar una
                    cantidad cuotas
                  </div>
                </div>

                <div class="autorow pull-right full-c-i m-top-ii">
                  <div class="quota-bxs" *ngIf="this.showFess[this.index]==true">
                    <div class="quot-i roboto-b f-white vcenter">
                      <div class="tabcell">
                        {{this.amountOfFees[this.index]}}
                      </div>
                    </div>

                    <div (click)="this.amountToPay(0,this.index);" class="quot-ii roboto-b f-gray-i vcenter">
                      <div class="tabcell">
                        -
                      </div>
                    </div>

                    <div (click)="this.amountToPay(1,this.index);" class="quot-ii roboto-b f-gray-i vcenter">
                      <div class="tabcell">
                        +
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="basicrow m-top-i" *ngIf="instal_equ > 0">
              <div class="logline full" [ngStyle]="{'display':this.showLine === true ? 'block' : 'none'}"></div>
              <div class="basicrow m-top totalpay-center">
                <div class="servs-monthly">
                  <div class="basicrow">
                    <span class="roboto-b">
                      {{this.payalert}}
                    </span><br />
                    <span class="f-red f-semi roboto-m">
                      {{this.payTotalDebt[this.index] | currency }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="basicrow m-top-i" *ngIf="instal_equ > 0">
  <div class="logline full" [ngStyle]="{'display':this.showLine === true ? 'block' : 'none'}"></div>
</div>
<div>
  <div class="basicrow m-top" *ngIf="instal_equ > 0" [ngStyle]="{'display':this.showLine === true ? 'block' : 'none'}">
    <a (click)="this.pay(this.index)" class="btns def-i red pull-right vcenter">
      <span class="tabcell">
        Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
      </span>
    </a>
  </div>
</div>